var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { elementTools } from '@joint/plus';
var DurationHandle = /** @class */ (function (_super) {
    __extends(DurationHandle, _super);
    function DurationHandle(options) {
        var _this = _super.call(this, options) || this;
        _this.affectedElements = [];
        return _this;
    }
    DurationHandle.prototype.preinitialize = function () {
        this.children = [{
                tagName: 'circle',
                selector: 'handle',
                attributes: {
                    class: 'jj-yamazumi-duration-handle',
                    r: 6,
                    fill: this.options.color
                }
            }];
    };
    DurationHandle.prototype.getPosition = function (view) {
        var model = view.model;
        return { x: model.size().width / 2, y: 0 };
    };
    DurationHandle.prototype.setPosition = function (view, coordinates) {
        var model = view.model;
        var duration = model.get('duration');
        var durationChange = -Math.round(coordinates.y / this.options.durationHeight);
        var stack = this.options.layout.model.getStackFromElement(view.model);
        var currentDuration = stack.elements.reduce(function (agg, el) { return agg + el.get('duration'); }, 0) - duration;
        var newDuration = Math.max(duration + durationChange, this.options.minDuration);
        if (currentDuration + newDuration > this.options.maxDuration) {
            newDuration = this.options.maxDuration - currentDuration;
        }
        model.set('duration', newDuration);
    };
    DurationHandle.prototype.onPointerDown = function (evt) {
        _super.prototype.onPointerDown.call(this, evt);
        this.relatedView.model.graph.set('animationDisabled', true);
    };
    DurationHandle.prototype.onPointerUp = function (evt) {
        _super.prototype.onPointerUp.call(this, evt);
        this.relatedView.model.graph.set('animationDisabled', false);
    };
    return DurationHandle;
}(elementTools.Control));
export { DurationHandle };
